import React, { CSSProperties, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { BoxWrapper } from 'components/Base';
import AssetAllocation from './AssetAllocation';
import SectorBreakdown from './SectorBreakdown';
import CountryBreakdown from './CountryBreakdown';
import RegionalBreakdown from './RegionalBreakdown';
import Tab from 'components/Base/Tabs/Tab';
import Tabs from '@material-ui/core/Tabs';

const useStyles = makeStyles({
  box: {
    height: '100%',
    boxShadow: 'none'
  },
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  }
});
interface BreakdownWrapperProps {
  existingOnly?: boolean;
}

const BreakdownWrapper = ({ existingOnly = false }: BreakdownWrapperProps) => {
  const [tab, setTab] = useState(0);

  const classes = useStyles();

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  const tabProps = (index: any) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
      style: {
        borderBottom: '2px solid #eaeaea',
        textTransform: 'none'
      } as CSSProperties
    };
  };

  const components = [
    AssetAllocation,
    SectorBreakdown,
    CountryBreakdown,
    RegionalBreakdown
  ] as any;

  const CurrentComponent = components[tab];

  return (
    <BoxWrapper
      title="Breakdown"
      className={classes.box}
      style={{ paddingBottom: '1rem', minHeight: '25.125rem' }}
    >
      <div style={{ margin: '1rem 1rem 0px' }}>
        <Tabs
          style={{ marginBottom: '1rem' }}
          value={tab}
          onChange={handleTabChange}
          TabIndicatorProps={{
            style: { display: 'none' }
          }}
        >
          <Tab label="Asset Class" {...tabProps(0)} />
          <Tab label="Sector" {...tabProps(1)} />
          <Tab label="Country" {...tabProps(2)} />
          <Tab label="Regional" {...tabProps(3)} />
        </Tabs>

        <CurrentComponent existingOnly={existingOnly} />
      </div>
    </BoxWrapper>
  );
};

export default BreakdownWrapper;
